export default [
  {
    path: 'simple',
    name: 'stock opname simple',
    component: () => import('@/views/app/stock-opname/page-simple.vue'),
    meta: { title: 'Stock Opname Simple' },
  },
]
